export const state = {
  mileages: [],
  mileage_items: [
    {
      driver_id: "",
      truck_id: "",
      mileage_amount: "",
      turn_boy: "",
      location_id: "",
      destination_id: "",
      consignment: "",
      remark: ""
    }
  ]
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/mileages/state.js